module.exports = __webpack_public_path__ + "media/Vechicle_in_front.5a6bb353.mp4";